import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GalleryPage from "../pages/gallery/page";
import MessagesPage from "../pages/messages/page";
import AboutPage from "../pages/about/page";
import GiftsPage from "../pages/gifts/page";
import AdminPage from "../pages/admin/page";
import NoticesPage from "../pages/notices/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/galeria",
    element: <GalleryPage />,
  },
  {
    path: "/caderno-de-recados",
    element: <MessagesPage />,
  },
  {
    path: "/sobre-a-festa",
    element: <AboutPage />,
  },
  {
    path: "/lista-de-presentes",
    element: <GiftsPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/avisos",
    element: <NoticesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
